import {environment} from '../../../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {OAuthService} from 'angular-oauth2-oidc';
import {CustomsValidators} from '../../validators/custom.validators';
import {throwError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PolicyApproversListService {
  urlPolicyApproversListPage: string;
  urlPeopleSearch: string;


  constructor(private http: HttpClient, private oauthService: OAuthService) {
    this.urlPolicyApproversListPage = `${environment.bffBaseUrl}/pages/policy-approver-list`;
    this.urlPeopleSearch = `${environment.bffBaseUrl}/pages/people-search`;
  }


  getPeropleSearchByletter(searchname) {
    const urlBuilder = this.urlPeopleSearch + '/byOne?searchData=' + searchname;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);

  }

  getPolicyApproversList(page, limit, urlFilter) {
    const headersObject = new HttpHeaders().set('AzureToken', this.oauthService.getAccessToken());
    const urlBuilder = this.urlPolicyApproversListPage + '?page=' + page + '&limit=' + limit + urlFilter;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder, {
      headers: headersObject
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

  updatePolicyApprover(policy) {
    const urlBuilder = `${this.urlPolicyApproversListPage}/${policy.policyId}`;
    const headersObject = new HttpHeaders().set('AzureToken', this.oauthService.getAccessToken());
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.put(urlBuilder, policy, {
      headers: headersObject
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

  generateReport() {
    const headersObject = new HttpHeaders().set('AzureToken', this.oauthService.getAccessToken());
    const urlBuilder = this.urlPolicyApproversListPage + '/download';

    CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder, {
      headers: headersObject,
      responseType: 'blob' as 'json'
    }).subscribe(
      (response: any) => {
        const dataType = response.type;
        const binaryData = [];
        binaryData.push(response);
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        downloadLink.setAttribute('download', 'policy_regional_approver_report.xlsx');
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }
    ) : throwError(CustomsValidators.msgNotValidUrl);
  }
}



